import { makeStyles } from '@material-ui/core';

export const usePlanTypeCardStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    padding: '12px 16px',
    boxSizing: 'border-box',
    borderRadius: '10px',
  },
  rootResident: {
    // Secondary-dark #55458e and 30% sylon-blue fill are not yet in theme tokens.
    border: '1px solid #55458e',
    backgroundColor: 'rgba(205, 213, 237, 0.3)',
  },
  rootTemplate: {
    // Aqua-extra-deep #00656c is not yet in theme.palette.colors.
    border: '1px solid #00656c',
    backgroundColor: theme.palette.primary.pastel,
  },
  avatar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    padding: '2px',
    boxSizing: 'border-box',
    borderRadius: '50px',
    flexShrink: 0,
    overflow: 'hidden',
  },
  avatarResident: {
    backgroundColor: theme.palette.colors.purpleDeep,
  },
  avatarTemplate: {
    backgroundColor: theme.palette.colors.aquaDeep,
  },
  icon: {
    color: theme.textWhite.main,
    fontSize: '24px',
    width: '24px',
    height: '24px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    flex: 1,
    minWidth: 0,
    color: theme.palette.colors.grey110,
  },
  name: {
    color: theme.palette.colors.grey110,
    fontFamily: 'Inter, sans-serif',
    fontWeight: '700 !important',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.32px',
  },
  description: {
    color: theme.palette.colors.grey110,
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'italic',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.32px',
  },
}));
